import * as React from 'react';
import {connect} from 'react-redux';
import {Dialog} from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@components/common/button/Button';
import {IArticleTarget, IArticleViewerContent} from '@app-types/article.types';
import {browseInArticleViewer, closeArticle, openArticle, readArticle} from '@services/article/article.actions';
import {styleColors} from 'src/main.style';
import {WebsiteFrame} from '../WebsiteFrame';
import {articleUrl, browsingUrl, IEmbedNavigation, isSwedish, knowledgeTitle, validatedEmbedNavigation} from '../articleNavigation';

interface IProps {
  content?: IArticleViewerContent;
  language: string;
  isChild: boolean;
  readArticles: number[];
  readArticle: (id: number) => void;
  openArticle: (target: IArticleTarget) => void;
  closeArticle: () => void;
  browseInArticleViewer: (target: {path: string; country?: string}) => void;
  onNavigateToApp: (path: string) => void;
}

export class ArticleModal extends React.Component<IProps> {
  public componentWillUnmount() {
    this.props.closeArticle();
  }

  public render() {
    const {content, language, isChild} = this.props;
    if (!content) return null;
    const backLabel = isSwedish(language) ? 'Tillbaka' : 'Back';
    const src = content.kind === 'article'
      ? articleUrl(content.value, language, content.country)
      : browsingUrl(language, content.value, isChild, content.country);
    return (
      <Dialog open={true} fullScreen={true} onClose={this.close} aria-label={knowledgeTitle(language)}>
        <div style={{height: '100%', display: 'flex', flexDirection: 'column', background: styleColors.white,
          paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)', boxSizing: 'border-box'}}>
          <div style={{display: 'flex', alignItems: 'center', padding: '4px 12px',
            borderBottom: `1px solid ${styleColors.greyLight3}`}}>
            <Button type="button" onClick={this.close} aria-label={backLabel}
              style={{minHeight: 44, padding: '8px 12px', fontSize: 16, fontWeight: 400, textTransform: 'none'}}>
              <ArrowBack fontSize="small"/>{backLabel}
            </Button>
          </div>
          <WebsiteFrame key={src} src={src} title={knowledgeTitle(language)} language={language}
            onNavigate={this.navigate}
            onRead={id => {
              if (!this.props.readArticles.includes(id)) this.props.readArticle(id);
            }}/>
        </div>
      </Dialog>
    );
  }

  private close = () => this.props.closeArticle();

  private navigate = (message: IEmbedNavigation) => {
    const navigation = validatedEmbedNavigation(message);
    if (!navigation) return;
    if (navigation.kind === 'article') {
      this.props.openArticle({reference: navigation.value, country: navigation.country});
    } else if (navigation.kind === 'browse') {
      this.props.browseInArticleViewer({path: navigation.value, country: navigation.country});
    } else {
      this.props.closeArticle();
      this.props.onNavigateToApp(navigation.value);
    }
  };
}

export default connect((state: any) => ({
  content: state.articleViewer?.content,
  language: state.user.language || 'EN',
  isChild: (state.family.family || []).some((member: any) => member.id === state.user.session.data.id && member.role === 'CHILD'),
  readArticles: state.article.readArticles || [],
}), {openArticle, closeArticle, browseInArticleViewer, readArticle})(ArticleModal);



// WEBPACK FOOTER //
// ./src/containers/knowledge/article/ArticleModal.tsx